import { render, staticRenderFns } from "./PerfilSidebar.vue?vue&type=template&id=345a6415&scoped=true"
import script from "./PerfilSidebar.vue?vue&type=script&lang=js"
export * from "./PerfilSidebar.vue?vue&type=script&lang=js"
import style0 from "./PerfilSidebar.vue?vue&type=style&index=0&id=345a6415&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345a6415",
  null
  
)

export default component.exports